import { useState, useCallback } from 'react';
import { usePipelineStages } from '../../services/queries';

export function usePipelineStagesDetails(buildId: number) {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const { 
    data: stagesData, 
    isLoading, 
    error, 
    refetch 
  } = usePipelineStages(buildId, isExpanded);

  const handleToggleExpanded = useCallback(() => {
    setIsExpanded(prev => !prev);
  }, []);

  const handleRefresh = useCallback(async () => {
    await refetch();
  }, [refetch]);

  return {
    // Data
    stagesData,
    
    // State
    isExpanded,
    isLoading,
    error,
    
    // Actions
    handleToggleExpanded,
    handleRefresh,
  };
}